import { ref, watch } from "vue"
import { useRouter } from "vue-router"
const formValidataAlert = ref(false)


const useMessage = () => {
    const router = useRouter();
    const alertInfo = ref({
        variant: "danger",
        content: "",
        icon: "ri-error-warning-line",
    })
    const iconObj = {
        danger: "ri-error-warning-line",
        success: "ri-check-line",
        warning: "ri-error-warning-line",
        info: "ri-information-line",
    }
    const openAlert = (info, time = 3000) => {
        formValidataAlert.value = false;
        if (info.content) {
            alertInfo.value.content = info.content;
            alertInfo.value.icon = iconObj[info.variant] ? iconObj[info.variant] : 'ri-check-line';
            alertInfo.value.variant = info.variant;
            formValidataAlert.value = true;
        }
        setTimeout(
            () => {
                formValidataAlert.value = false;
            },
            time
        );
    }
    watch(() => router.currentRoute.value.path, () => {
        //路由变化时则关闭弹框
        // formValidataAlert.value = false;
    }, { immediate: true })

    return {
        alertInfo,
        openAlert,
        formValidataAlert
    }
}

export default useMessage